import TalentListPage from '../components/Talent/TalentListPage'
import talentStatusesConfig from '../../../shared/talentStatuses.json'

const PROJECT_STATUSES = talentStatusesConfig.PROJECT_STATUSES || [];

const EmployeesProject = () => {
  return (
    <>
      <title>Project Employees | Talent Service</title>
      <TalentListPage
        talentType="employee"
        statusNames={PROJECT_STATUSES.join(', ')}
        pageTitle="Project Employees"
        pageDescription="Employees on projects: Project, Part Project + Part Project"
        defaultFilters={{ is_active: 'true', current_only: 'true' }}
      />
    </>
  )
}

export default EmployeesProject
